module.exports = __webpack_public_path__ + "static/media/example1.623e942a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/quiz/image/example1.png
// module id = 307
// module chunks = 0